<template>
  <div class="scss-click-effect">
    <div class="py-3 text-start d-flex flex-row">
      <i class="bi bi-x style-icon d-flex align-items-center" />
      <span class="fw-bold ms-2 d-flex align-items-center">Close</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Close Button",
};
</script>

<style scoped>
.style-button-container {
  width: 100px;
}

.style-icon {
  -webkit-text-stroke: 1px #4a4a4a;
  font-size: 25px;
}
</style>
